import React, { useState } from "react";
import { Grid, Paper } from "@material-ui/core";
import Chart from "react-apexcharts";
import { stateChart } from "../../../utils/stateChart";
import { Link } from "react-router-dom";

//const initialState = stateChart(['ABIERTOS', 'CERRADOS']);
const initialState = stateChart([
  "SON MULTIDISCIPLINARIOS",
  "NO SON MULTIDISCIPLINARIOS",
]);

const ReportByMulti = ({ data }) => {
  const [state] = useState(initialState);

  const quantityProjectsIsByCarrer = () => {
    const res = data.filter((project) => project.careers.length >= 2);
    return res.length;
  };

  const quantityProjectsIsNByCarrer = () => {
    const res = data.filter((project) => project.careers.length < 2);
    return res.length;
  };

  const listItemsIs = data
    .filter((project) => project.careers.length >= 2)
    .map((filteredPerson) => (
      <Link
        style={{ textDecoration: "none", textDecorationColor: "black" }}
        to={`/proyecto/${filteredPerson.slug}`}
      >
        <li> {filteredPerson.code} </li>
      </Link>
    ));

  const listItemsIsN = data
    .filter((project) => project.careers.length < 2)
    .map((filteredPerson) => (
      <Link
        style={{ textDecoration: "none" }}
        to={`/proyecto/${filteredPerson.slug}`}
      >
        {" "}
        <li>{filteredPerson.code}</li>
      </Link>
    ));

  return (
    <Grid item xs={8} sm={8} md={12}>
      <Paper className="paper" style={{ marginTop: "2em" }}>
        <Chart
          options={state.options}
          series={[quantityProjectsIsByCarrer(), quantityProjectsIsNByCarrer()]}
          type="pie"
          height={380}
          className="chart"
        />
      </Paper>
      <Paper className="paper" style={{ marginTop: "2em" }}>
        <h3> Lista de Proyectos Multidisciplinarios</h3>
        <ol>{listItemsIs}</ol>
      </Paper>
      <Paper className="paper" style={{ marginTop: "2em" }}>
        <h3> Lista de Proyectos que no son Multidisciplinarios</h3>
        <ol> {listItemsIsN}</ol>
      </Paper>
    </Grid>
  );
};

export default ReportByMulti;
